import React from 'react';

import WebUiPageWrapper from '../components/page-wrapper';

const LICENSE_ITEMS = [
  {
    name: 'asio',
    version: '1.18.2',
    license: 'Boost Software License 1.0',
    url: 'http://downloads.sourceforge.net/project/asio/asio/1.18.2%20%28Stable%29/asio-1.18.2.tar.gz',
  },
  {
    name: 'busybox',
    version: '1.37.0',
    license: 'GPL-2.0-only',
    url: 'https://www.busybox.net/downloads/busybox-1.37.0.tar.bz2',
  },
  {
    name: 'chrony',
    version: '4.6.1',
    license: 'GPL-2.0-only AND RSA-MD',
    url: 'https://chrony-project.org/releases/chrony-4.6.1.tar.gz',
  },
];

export default function WebUiLicensesPage() {
  return (
    <WebUiPageWrapper titleList={['Third Party Notices and/or Licenses']}>
      <div className="flex w-full flex-col gap-2">
        <p className="text-xs">
          This product includes open source software originating from third
          parties.
          <br />
          The specific license terms associated with this software are included
          in each software package respectively. TRONTEQ will provide you with a
          copy of the applicable source code files used in this product if the
          license terms entitle you to it. For any request regarding source code
          please contact our support via{' '}
          <a
            target="_blank"
            className="text-blue-700 underline"
            rel="noopener noreferrer"
            href="https://www.tronteq.com/"
          >
            https://www.tronteq.com
          </a>
          .
        </p>
      </div>
      <div className="flex w-full flex-col gap-2">
        <h4 className="font-bold">Third Party Software</h4>
        <table className="webui-table w-full">
          <thead>
            <tr className="webui-table-row-head">
              <th>Software</th>
              <th>Version</th>
              <th>License</th>
              <th>URL</th>
            </tr>
          </thead>
          <tbody>
            {LICENSE_ITEMS.map((item) => (
              <tr key={item.name} className="webui-table-row-content">
                <td>{item.name}</td>
                <td>{item.version}</td>
                <td>{item.license}</td>
                <td className="truncate">{item.url}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </WebUiPageWrapper>
  );
}
